import { HttpErrorResponse } from '@angular/common/http';
import { IPersonDTO } from '@modeso/types__aumico-lib-companies-be';
import { Observable } from 'rxjs';
import { IPersonExportDto } from '../dtos/person-export-dto.interface';
import { IPersonExportTableHeaders } from '../dtos/person-export-table-header-dto.interface';
import { PersonsFilter } from '../interfaces/persons-filter.interface';
import { PersonBulkUpdate } from '../services/persons.service';
import { TasksUpdate } from '../enums/tasks-update.enum';

/** REV-22155 — what the persons pages may do with the store: one `dispatch…` per action, one read per result. */
export interface IPersonsProvider {
    dispatchPersonsList(): void;
    dispatchPersonsOfCompany(companyId: string): void;
    dispatchPersonById(id: string): void;
    dispatchCreatePerson(person: IPersonDTO): void;
    dispatchUpdatePerson(person: IPersonDTO, tasksUpdate?: TasksUpdate): void;
    dispatchUpdatePersonStatus(id: string, active: boolean): void;
    dispatchDeletePerson(id: string): void;
    dispatchBulkUpdatePersons(persons: PersonBulkUpdate[], tasksUpdate?: TasksUpdate): void;
    dispatchSetPersonsFilter(filter: PersonsFilter): void;
    dispatchExportPersonsDataAsExcel(
        tableHeaders: IPersonExportTableHeaders,
        persons: IPersonExportDto[],
        fileName: string,
    ): void;
    resetPersons(): void;
    resetPersonsErrors(): void;

    getPersons$(): Observable<IPersonDTO[]>;
    getPersonsOfCompany$(): Observable<IPersonDTO[]>;
    getSelectedPerson$(): Observable<IPersonDTO | null>;
    getPersonsFilter$(): Observable<PersonsFilter>;
    getPersonsError$(): Observable<HttpErrorResponse | null>;

    getSavePersonResult$(): Observable<
        { type: string; payload: IPersonDTO } | { type: string; payload: HttpErrorResponse }
    >;
    getDeletePersonResult$(): Observable<{ type: string; id: string } | { type: string; payload: HttpErrorResponse }>;
    getBulkUpdatePersonsResult$(): Observable<
        { type: string; payload: IPersonDTO[] } | { type: string; payload: HttpErrorResponse }
    >;
}
